class Store {
    _userInfo = {};

    constructor() {
    }

    get userInfo() {
        return this._userInfo;
    }
    set userInfo(value) {
        this._userInfo = value;
    }

    reset() {
        this._userInfo = {};
    }
}

const store = new Store();

export default store;


// WEBPACK FOOTER //
// ./src/components/questionnaire-store.js